import { FC } from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import AddIcon from '@mui/icons-material/Add'
import useCallbackDebounced from '../../../../hooks/shared/useCallbackDebounced'

const TemplateTile: FC<{
  id: string
  url?: string
  name: string
  template?: any | null
  onTemplateSelected: (args?: { defaultTemplateJSON: any }) => void
}> = ({ id, url, name, template, onTemplateSelected }) => {
  const handleTemplateClicked = useCallbackDebounced(() => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    onTemplateSelected({ defaultTemplateJSON: template })
  }, [onTemplateSelected, template])
  return (
    <Box
      component={'li'}
      sx={{
        flex: 1,
        listStyle: 'none',
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        backgroundColor: 'pageBackground',
        height: 'auto',
        width: '100%',
      }}
    >
      <Box
        id={id}
        sx={theme => ({
          cursor: 'pointer',
          borderRadius: 1,
          display: 'flex',
          position: 'relative',
          flexDirection: 'column',
          backgroundColor: 'white',
          aspectRatio: '1 / 1.4',
          border: `2px solid ${theme.palette.text.primary}`,
        })}
        onClick={handleTemplateClicked}
      >
        {url ? (
          <Box component={'img'} sx={{ width: '100%' }} src={url} />
        ) : (
          <Box
            component={'div'}
            sx={{
              display: 'flex',
              flex: 1,
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <AddIcon
              sx={{
                fontSize: 72,
                color: 'text.secondary',
              }}
            />
          </Box>
        )}
      </Box>
      <Box
        sx={{
          padding: 0.5,
        }}
      >
        <Typography component={'span'} variant="subtitle2">
          {name}
        </Typography>
      </Box>
    </Box>
  )
}

export default TemplateTile
